const state = {
  menuHeaderOpen: false,
  isHome: true
}
const getters = {}
const mutations = {
  setIsHomePage(state, status) {
    state.isHome = status
  }
}
const actions = {
  resetLayout({ commit }, page) {
    actions.closeMenuHeader()
    const status = page.path === '/'
    commit('setIsHomePage', status)
  },
  closeMenuHeader() {
    if (state.menuHeaderOpen) {
      document.querySelector('Header').classList.remove('_show')
      document.querySelector('body').classList.remove('_scroll-prevent')
    }
    state.menuHeaderOpen = false
  },
  openMenuHeader() {
    if (!state.menuHeaderOpen) {
      document.querySelector('Header').classList.add('_show')
      document.querySelector('body').classList.add('_scroll-prevent')
    }
    state.menuHeaderOpen = true
  },
  toggleMenuHeader({ state }) {
    if (!state.menuHeaderOpen) {
      actions.openMenuHeader()
    } else {
      actions.closeMenuHeader()
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
